import jsPDF from "jspdf";
import logoImage from "../assets/images/nnfitwatermark.png";

export const generateDietPDF = (member, dietPlan, gym) => {
  // =====================================================
  // VALIDATION
  // =====================================================

  if (!gym) {
    alert("Gym details not found.");
    return;
  }

  if (!member) {
    alert("Member details not found.");
    return;
  }

  if (!dietPlan) {
    alert("Diet Plan not assigned.");
    return;
  }

  try {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // =====================================================
    // HEADER
    // =====================================================

    doc.setFillColor(79, 70, 229);
    doc.rect(0, 0, pageWidth, 34, "F");

    // =====================================================
    // GYM LOGO
    // =====================================================

    if (gym?.logoBase64) {
      try {
        let gymLogoType = "PNG";

        if (
          gym.logoBase64.startsWith("data:image/jpeg") ||
          gym.logoBase64.startsWith("data:image/jpg")
        ) {
          gymLogoType = "JPEG";
        }

        doc.addImage(gym.logoBase64, gymLogoType, 15, 6, 22, 22);
      } catch (error) {
        console.error("Gym Logo Error:", error);
      }
    }

    // =====================================================
    // NN FIT LOGO
    // =====================================================

    try {
      doc.addImage(logoImage, "PNG", pageWidth - 37, 7, 22, 22);
    } catch (error) {
      console.error("NN FIT Logo Error:", error);
    }

    // =====================================================
    // GYM NAME
    // =====================================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.setTextColor(255, 255, 255);

    doc.text(gym?.gymName || "GYM SAAS", pageWidth / 2, 15, {
      align: "center",
    });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);

    doc.text("Diet & Nutrition Management", pageWidth / 2, 23, {
      align: "center",
    });

    // =====================================================
    // TITLE
    // =====================================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(22);
    doc.setTextColor(30, 30, 30);

    doc.text("DIET PLAN", pageWidth / 2, 50, {
      align: "center",
    });

    doc.setDrawColor(255, 120, 0);
    doc.setLineWidth(0.8);

    doc.line(15, 56, pageWidth - 15, 56);

    // =====================================================
    // GYM INFORMATION
    // =====================================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(79, 70, 229);

    doc.text("Gym Information", 15, 68);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10.5);
    doc.setTextColor(50, 50, 50);

    doc.text(`Gym Name : ${gym?.gymName || "-"}`, 15, 76);

    doc.text(`Owner : ${gym?.ownerName || "-"}`, 15, 83);

    doc.text(`Phone : ${gym?.phone || "-"}`, 15, 90);

    doc.text(`Address : ${gym?.address || "-"}`, 15, 97);

    // =====================================================
    // MEMBER INFORMATION
    // =====================================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(79, 70, 229);

    doc.text("Member Information", 15, 110);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10.5);
    doc.setTextColor(50, 50, 50);

    // IMPORTANT:
    // Use custom Member ID
    // NOT Firestore document ID

    doc.text(`Member ID : ${member?.memberId || "-"}`, 15, 118);

    doc.text(`Member Name : ${member?.fullName || "-"}`, 15, 125);

    doc.text(`Phone : ${member?.phone || "-"}`, 15, 132);

    doc.text(`Trainer : ${member?.trainerName || "-"}`, 15, 139);

    doc.text(`Goal : ${dietPlan?.goal || "-"}`, 15, 146);

    // =====================================================
    // WATERMARK
    // =====================================================

    try {
      doc.setGState(
        new doc.GState({
          opacity: 0.06,
        }),
      );

      doc.addImage(logoImage, "PNG", 55, 145, 100, 100);

      doc.setGState(
        new doc.GState({
          opacity: 1,
        }),
      );
    } catch (error) {
      console.error("Watermark Error:", error);
    }

    // =====================================================
    // DAILY MEAL PLAN
    // =====================================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.setTextColor(79, 70, 229);

    doc.text("Daily Meal Plan", 15, 160);

    // Background box

    doc.setFillColor(248, 248, 248);

    doc.roundedRect(15, 165, 180, 58, 3, 3, "F");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10.5);
    doc.setTextColor(50, 50, 50);

    // Meal labels

    doc.text("Breakfast", 20, 174);

    doc.text("Morning Snack", 20, 184);

    doc.text("Lunch", 20, 194);

    doc.text("Evening Snack", 20, 204);

    doc.text("Dinner", 20, 214);

    // Meal values

    doc.setFont("helvetica", "normal");

    const mealX = 58;

    doc.text(`: ${dietPlan?.breakfast || "-"}`, mealX, 174);

    doc.text(`: ${dietPlan?.morningSnack || "-"}`, mealX, 184);

    doc.text(`: ${dietPlan?.lunch || "-"}`, mealX, 194);

    doc.text(`: ${dietPlan?.eveningSnack || "-"}`, mealX, 204);

    doc.text(`: ${dietPlan?.dinner || "-"}`, mealX, 214);

    // =====================================================
    // NUTRITION SUMMARY
    // =====================================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.setTextColor(79, 70, 229);

    doc.text("Nutrition Summary", 15, 238);

    // Nutrition cards

    const nutrition = [
      ["Calories", `${dietPlan?.calories || "-"} kcal`],
      ["Protein", `${dietPlan?.protein || "-"} g`],
      ["Carbs", `${dietPlan?.carbs || "-"} g`],
      ["Fat", `${dietPlan?.fat || "-"} g`],
      ["Water", `${dietPlan?.water || "-"} L`],
    ];

    let nutritionX = 15;

    nutrition.forEach(([label, value], index) => {
      doc.setFillColor(
        index % 2 === 0 ? 245 : 250,
        index % 2 === 0 ? 245 : 250,
        index % 2 === 0 ? 245 : 250,
      );

      doc.roundedRect(nutritionX, 244, 33, 24, 2, 2, "F");

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.setTextColor(100);

      doc.text(label, nutritionX + 3, 251);

      doc.setFontSize(9.5);
      doc.setTextColor(20);

      doc.text(String(value), nutritionX + 3, 261);

      nutritionX += 36;
    });

    // =====================================================
    // NOTES
    // =====================================================

    let finalY = 278;

    if (dietPlan?.notes) {
      finalY = 280;

      // Check if notes need another page

      if (finalY > pageHeight - 40) {
        doc.addPage();

        finalY = 25;
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.setTextColor(79, 70, 229);

      doc.text("Notes", 15, finalY);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(60, 60, 60);

      const noteLines = doc.splitTextToSize(dietPlan.notes, 170);

      doc.text(noteLines, 15, finalY + 8);
    }

    // =====================================================
    // FOOTER
    // =====================================================

    const totalPages = doc.internal.getNumberOfPages();

    for (let page = 1; page <= totalPages; page++) {
      doc.setPage(page);

      doc.setDrawColor(220, 220, 220);

      doc.setLineWidth(0.4);

      doc.line(15, pageHeight - 18, pageWidth - 15, pageHeight - 18);

      doc.setFont("helvetica", "normal");

      doc.setFontSize(9);
      doc.setTextColor(120, 120, 120);

      doc.text("Powered By NN FIT", 15, pageHeight - 10);

      doc.text(
        `Generated : ${new Date().toLocaleString()}`,
        pageWidth / 2,
        pageHeight - 10,
        {
          align: "center",
        },
      );

      doc.text(
        `Page ${page} of ${totalPages}`,
        pageWidth - 15,
        pageHeight - 10,
        {
          align: "right",
        },
      );
    }

    // =====================================================
    // SAVE PDF
    // =====================================================

    const fileName = member?.memberId || member?.fullName || "Member";

    doc.save(`${fileName}-DietPlan.pdf`);
  } catch (error) {
    console.error("Diet PDF Error:", error);

    alert("Failed to generate Diet PDF.");
  }
};
